import { createRequiredContext } from 'src/context/createRequiredContext';

import type { IEscrowDashboardCardContextValue } from './types';

const [useEscrowDashboardCard, EscrowDashboardCardProvider] = createRequiredContext<IEscrowDashboardCardContextValue>();

export { useEscrowDashboardCard, EscrowDashboardCardProvider };
